import styled from 'styled-components';

export const ClaimEntryStyles = styled('figure')`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  padding: 0;
  position: relative;
  border: 1px solid ${({ theme }) => theme.neutrals['200']};
  margin: 0.5rem 0 0;

  > figcaption {
    padding: 0.5rem 1rem 1rem;
  }

  > .image {
    overflow: hidden;

    img {
      width: 100%;
      max-height: 225px;
      object-fit: cover;
    }
  }

  .detail-header {
    display: flex;
    color: ${({ theme }) => theme.neutrals['700']};
    margin-bottom: 0.5rem;
  }

  .voted {
    margin-right: 1rem;
    height: 1rem;
    img {
      width: 4rem;
      transform: translateY(-1.25rem);
    }
  }

  .keys {
    > span {
      display: flex;
      > sl-icon {
        margin-right: 0.5rem;
      }

      & + span {
        margin-top: 0.25rem;
      }
    }
  }

  > .title {
  }

  .comment {
    color: ${({ theme }) => theme.neutrals['700']};
    margin: 0.25rem 0 0;
  }
`;
